import { render, staticRenderFns } from "./CoveragePageFormulaMulti.vue?vue&type=template&id=0899ed53"
import script from "./CoveragePageFormulaMulti.vue?vue&type=script&lang=js"
export * from "./CoveragePageFormulaMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports